<template>
  <request-form mode="Accepted">
    <p>
      発行依頼の修正を受け付けました。<br>
      ご登録のメールアドレス宛にメールを送信しましたので、ご確認ください。
    </p>
    <text-browse-item label="発行依頼ID" :value="id" />
    <text-browse-item label="依頼物件名・棟名" :value="building.name" />
    <text-browse-item label="依頼物件名・棟名（カナ）" :value="building.name_kana" />
    <text-browse-item label="依頼物件住戸番号" :value="buildingHouseNumber" />
    <text-browse-item label="所有者" :value="owner_name" />
    <text-browse-item label="依頼物件郵便番号" :value="building.postal_code" />
    <text-browse-item label="依頼物件住所" :value="building.address" />
    <div v-show="requiredDocumentType !== $constant.DOCUMENT_TYPE.HIDDEN">
      <text-browse-item label="依頼主確認書類" :value="requiredDocument" />
    </div>
    <text-browse-item label="発行書類" :value="issueDocumentName" />
    <text-browse-item label="手数料の支払方法" :value="paymentMethodName" />
    <text-browse-with-unit-item label="請求金額" :value="billingPrice" unit="円" />
    <textarea-browse-item label="備考" :value="note" />
    <text-browse-item v-if="isOwner" label="依頼者住所" :value="ownerAddress" />
    <template #expansion-buttons-center v-if="!isGuest">
      <router-button text="引き続き発行依頼を行う" :to="{name: 'IssuanceRequestRegister'}" />
      <router-button text="TOPに戻る" :to="{name: 'Top'}" />
    </template>
  </request-form>
</template>

<script>
import {mapState, mapGetters, mapMutations} from "vuex";
import {convertPaymentMethodToName} from '@/constants/payment_method';
import RequestForm from '@/views/templates/forms/RequestForm';
import TextBrowseItem from "@/views/molecules/browseItems/TextBrowseItem";
import TextBrowseWithUnitItem from '@/views/molecules/browseItems/TextBrowseWithUnitItem';
import TextareaBrowseItem from "@/views/molecules/browseItems/TextareaBrowseItem";
import RouterButton from '@/views/molecules/buttons/RouterButton';

export default {
  name: 'IssuanceRequestEditorAccepted',
  components: {
    RequestForm,
    TextBrowseItem,
    TextBrowseWithUnitItem,
    TextareaBrowseItem,
    RouterButton,
  },
  inject: [
    '$constant'
  ],
  computed: {
    ...mapState('issuance_request_form', {
      id: state => state.data.id ? state.data.id.toString() : null,
      building: state => state.data.building,
      buildingHouseNumber: state => state.data.building_house_number,
      owner_name: state => state.data.owner_name,
      note: state => state.data.note,
      payment_method_code: state => state.data.payment_method,
      requiredDocumentType: state => state.data.required_document_type,
      ownerAddress: state => state.data.owner_address,
    }),
    ...mapState('account', {
      isGuest: state => state.is_guest,
      guestType: state => state.guest_type,
    }),
    ...mapGetters('issuance_request_form', [
      'requiredDocumentTypeName',
      'requiredDocumentUploadFileName',
      'issueDocumentName',
      'billingPrice',
    ]),
    requiredDocument() {
      return this.requiredDocumentTypeName + ' ' + this.requiredDocumentUploadFileName;
    },
    paymentMethodName() {
      return convertPaymentMethodToName(this.payment_method_code);
    },
    isOwner() {
      return this.guestType === this.$constant.GUEST_TYPE.OWNER.code;
    },
  },
  beforeRouteLeave() {
    this.resetData();
  },
  methods: {
    ...mapMutations('issuance_request_form', [
      'resetData',
    ]),
  }
}
</script>
